export const metadata = {
  student_info: "Dyslexia accommodated (+10% SM123 time, +30% MST124 time). Works full-time with flexible hours.",
  retreat_info: "4-day study retreat integrated from March 20th to March 23rd (24 total hours: exactly 6 hours per day including travel days).",
  personal_commitments: "Saj and Ailsa wedding in London on June 5th. Travel days on June 4th and 6th accommodated with exactly 4 hours of travel-study.",
  strategy: "Hourly task breakdowns included to eliminate ambiguity. Software catch-up cleared during the retreat. Standard 2 rest-days per week resumed.",
  module_deadlines: "48-hour advance submission rule applied to TMAs and iCMAs.",
  exam_info: "MST124 Exam is Wednesday 3 June. SM123 Exam is Wednesday 10 June."
};

export const calendar = [
  {
    date: "2026-03-10",
    day: "Tuesday",
    module: "MST124",
    topic: "TMA03",
    study_hours: 8,
    tasks: ["[8.0 hrs] Finalise assignment covering Units 7 & 8, complete and submit today"],
    tutorials: [],
    notes: "Evening free as requested."
  },
  {
    date: "2026-03-11",
    day: "Wednesday",
    module: "SM123",
    topic: "TMA03 - Day 1",
    study_hours: 5,
    tasks: ["[2.5 hrs] Questions on Practical 2 (Cloud Chamber)", "[2.5 hrs] Topic 4 questions (sketching hydrogen orbitals)"],
    tutorials: [],
    notes: "MST124 TMA03 official cut-off today."
  },
  {
    date: "2026-03-12",
    day: "Thursday",
    module: "SM123",
    topic: "TMA03 - Day 2",
    study_hours: 5,
    tasks: ["[2.5 hrs] Topic 5 questions (Stefan-Boltzmann law)", "[2.5 hrs] Topic 6 questions (half-life calculations)"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-03-13",
    day: "Friday",
    module: "SM123",
    topic: "TMA03 - Day 3",
    study_hours: 5,
    tasks: ["[3.0 hrs] Final reflective questions", "[2.0 hrs] Format zip files (Word, PowerPoint, Script) and submit to meet 48-hour rule"],
    tutorials: [],
    notes: "Evening free as requested."
  },
  {
    date: "2026-03-14",
    day: "Saturday",
    module: "SM123",
    topic: "Topic 6: Nuclei & Particles",
    study_hours: 5,
    tasks: ["[1.5 hrs] Part 1: Mass-energy equivalence, matter-antimatter annihilation", "[3.5 hrs] Start Part 2: Conservation laws and alpha/beta/gamma decay mechanisms"],
    tutorials: [],
    notes: "Evening free as requested. (Topic 6 total accommodated time is 14.3 hours)"
  },
  {
    date: "2026-03-15",
    day: "Sunday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: [],
    notes: "Take a well-deserved break before your busy week!"
  },
  {
    date: "2026-03-16",
    day: "Monday",
    module: "SM123",
    topic: "Topic 6: Nuclei & Particles",
    study_hours: 5,
    tasks: ["[3.5 hrs] Finish Part 2: Radioactive half-life, nuclear fission and fusion", "[1.5 hrs] Start Part 3: Particle physics, leptons, and quarks"],
    tutorials: [],
    notes: "SM123 TMA03 official cut-off today."
  },
  {
    date: "2026-03-17",
    day: "Tuesday",
    module: "SM123",
    topic: "Topic 6: Nuclei & Particles",
    study_hours: 4,
    tasks: ["[4.0 hrs] Finish Part 3: Hadrons, Strong and Weak interactions"],
    tutorials: ["20:00-21:00 | SM123 Components of the Universe [Overview, Relaxed]"],
    notes: "Topic 6 now fully complete."
  },
  {
    date: "2026-03-18",
    day: "Wednesday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: [],
    notes: "Taking a rest day before your intensive study retreat."
  },
  {
    date: "2026-03-19",
    day: "Thursday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: ["19:00-20:30 | MST124 Unit 8 Integration Methods - For Those Working Behind"],
    notes: "Optional tutorial on your rest day before the retreat."
  },
  {
    date: "2026-03-20",
    day: "Friday",
    module: "SM123",
    topic: "Retreat Outbound: Python Catch-up",
    study_hours: 6,
    tasks: ["[4.0 hrs] Python 1 Part 1: Jupyter Notebooks, data types, arithmetic operators", "[2.0 hrs] Python 1 Part 2: Iterations (for/while loops) and selection"],
    tutorials: [],
    notes: "6 hours of study on the outbound ferry. Focus entirely on the Open Computing Lab (OCL).",
    isRetreat: true
  },
  {
    date: "2026-03-21",
    day: "Saturday",
    module: "SM123",
    topic: "Retreat Day 1: Python Catch-up",
    study_hours: 6,
    tasks: ["[1.5 hrs] Finish Python 1 Part 2 (math module)", "[4.5 hrs] Start Python 2: Writing custom functions"],
    tutorials: [],
    notes: "Day 1 of the retreat.",
    isRetreat: true
  },
  {
    date: "2026-03-22",
    day: "Sunday",
    module: "Both",
    topic: "Retreat Day 2: Python & Maxima Catch-up",
    study_hours: 6,
    tasks: ["[3.0 hrs] Finish Python 2: Importing external physics packages", "[3.0 hrs] Maxima Catch-up Part 1: Algebra, plotting functions, basic equations"],
    tutorials: [],
    notes: "Day 2 of the retreat. Python backlog is now officially cleared!",
    isRetreat: true
  },
  {
    date: "2026-03-23",
    day: "Monday",
    module: "MST124",
    topic: "Retreat Return: Maxima & Matrices",
    study_hours: 6,
    tasks: ["[4.0 hrs] Maxima Catch-up Part 2: Calculus (derivatives and integrals)", "[2.0 hrs] Start Unit 9 Matrices: Matrix notation, addition, scalar multiplication"],
    tutorials: [],
    notes: "6 hours of study on the return ferry. Retreat successfully completed! Maxima backlog is officially cleared!",
    isRetreat: true
  },
  {
    date: "2026-03-24",
    day: "Tuesday",
    module: "MST124",
    topic: "Unit 9: Matrices",
    study_hours: 5,
    tasks: ["[3.0 hrs] Unit 9: Matrix multiplication and networks", "[2.0 hrs] Unit 9: Identity matrix, determinants, and inverses"],
    tutorials: ["19:00-20:30 | MST124 Unit 10 Sequences & Series"],
    notes: "Back to normal schedule."
  },
  {
    date: "2026-03-25",
    day: "Wednesday",
    module: "MST124",
    topic: "Unit 9: Matrices",
    study_hours: 4,
    tasks: ["[4.0 hrs] Unit 9: Solving simultaneous linear equations & Maxima practice"],
    tutorials: ["19:00-20:00 | SM123 Python 3 [Overview, Relaxed]"],
    notes: "Finish Unit 9."
  },
  {
    date: "2026-03-26",
    day: "Thursday",
    module: "SM123",
    topic: "Topic 7: Components of the Universe",
    study_hours: 4,
    tasks: ["[4.0 hrs] Start Part 1: Observing the Universe, angular size/resolution"],
    tutorials: ["19:00-20:00 | MST124 Unit 9 Matrices - For Those Working Behind"],
    notes: "(Topic 7 total accommodated time is ~16 hours)"
  },
  {
    date: "2026-03-27",
    day: "Friday",
    module: "SM123",
    topic: "Topic 7: Components of the Universe",
    study_hours: 4,
    tasks: ["[1.5 hrs] Finish Part 1: Measuring distance to the Moon", "[2.5 hrs] Start Part 2: Planetary systems and Kepler's third law"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-03-28",
    day: "Saturday",
    module: "SM123",
    topic: "Topic 7: Components of the Universe",
    study_hours: 4,
    tasks: ["[3.0 hrs] Finish Part 2: Exoplanet transits", "[1.0 hrs] Start Part 3: Galaxies and Hubble tuning-fork"],
    tutorials: ["10:30-12:00 | MST124 Unit 10 Sequences & Series - Gentle"],
    notes: ""
  },
  {
    date: "2026-03-29",
    day: "Sunday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-03-30",
    day: "Monday",
    module: "SM123",
    topic: "Topic 7: Components of the Universe",
    study_hours: 4,
    tasks: ["[4.0 hrs] Finish Part 3: Galaxy rotation curves and dark matter"],
    tutorials: [],
    notes: "Finish Topic 7."
  },
  {
    date: "2026-03-31",
    day: "Tuesday",
    module: "MST124",
    topic: "Unit 10: Sequences and Series",
    study_hours: 5,
    tasks: ["[5.0 hrs] Sections 1 & 2: Sequence notation, recurrence systems, arithmetic/geometric sequences"],
    tutorials: ["18:30-20:00 | MST124 Unit 10 Sequences & Series"],
    notes: ""
  },
  {
    date: "2026-04-01",
    day: "Wednesday",
    module: "MST124",
    topic: "Unit 10: Sequences and Series",
    study_hours: 4,
    tasks: ["[4.0 hrs] Section 3: Graphs and long-term behaviour, limits to infinity"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-04-02",
    day: "Thursday",
    module: "MST124",
    topic: "Unit 10: Sequences and Series",
    study_hours: 5,
    tasks: ["[3.0 hrs] Section 4: Sum of finite/infinite series, Sigma notation", "[2.0 hrs] Section 5: Binomial Theorem (Pascal's triangle)"],
    tutorials: ["17:30-19:00 | MST124 Unit 9 Matrices - Gentle"],
    notes: "Unit 11 is optional and not assessed, so we skip it. Finish Unit 10."
  },
  {
    date: "2026-04-03",
    day: "Friday",
    module: "SM123",
    topic: "Python 3: Arrays and Plotting",
    study_hours: 4,
    tasks: ["[2.0 hrs] OCL Notebooks 1 & 2: Initialising arrays", "[2.0 hrs] Using pyplot from matplotlib"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-04-04",
    day: "Saturday",
    module: "SM123",
    topic: "Python 3 & Topic 8",
    study_hours: 5,
    tasks: ["[3.5 hrs] Write program for radioactive decay (half-life curves) & submit for peer review", "[1.5 hrs] Topic 8 Part 1 (Start): Pluto and Kuiper Belt"],
    tutorials: [],
    notes: "Start of Official Break Week. Using the time to comfortably stay ahead. (Topic 8 total accommodated time is ~15.5 hours)"
  },
  {
    date: "2026-04-05",
    day: "Sunday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-04-06",
    day: "Monday",
    module: "SM123",
    topic: "Topic 8: Exploring the Solar System",
    study_hours: 5,
    tasks: ["[2.0 hrs] Finish Topic 8 Part 1: Comets", "[3.0 hrs] Start Topic 8 Part 2: Asteroids and meteorites"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-04-07",
    day: "Tuesday",
    module: "SM123",
    topic: "Topic 8: Exploring the Solar System",
    study_hours: 5,
    tasks: ["[1.5 hrs] Finish Topic 8 Part 2: Virtual Microscope rock analysis", "[3.5 hrs] Start Topic 8 Part 3: Mars landscapes and meteorites"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-04-08",
    day: "Wednesday",
    module: "SM123",
    topic: "Topic 8: Exploring the Solar System",
    study_hours: 5,
    tasks: ["[4.0 hrs] Topic 8 Part 4: The Moon and icy moons (Europa, Enceladus, Titan)", "[1.0 hrs] General Topic 8 Review & summary notes"],
    tutorials: ["18:00-20:00 | Unit 12 Complex Numbers - Joint MST124/M140"],
    notes: "Finish Topic 8."
  },
  {
    date: "2026-04-09",
    day: "Thursday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: ["17:30-19:00 | MST124 Unit 12 Complex Numbers - Gentle"],
    notes: "Optional tutorial to drop into on your rest day."
  },
  {
    date: "2026-04-10",
    day: "Friday",
    module: "MST124",
    topic: "Unit 12: Complex Numbers",
    study_hours: 5,
    tasks: ["[2.5 hrs] Sections 1 & 2: Intro to i squared = -1, real/imaginary parts", "[2.5 hrs] Argand diagrams (complex plane)"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-04-11",
    day: "Saturday",
    module: "MST124",
    topic: "Unit 12: Complex Numbers",
    study_hours: 5,
    tasks: ["[2.5 hrs] Sections 3 & 4: Modulus and Argument", "[2.5 hrs] Convert Cartesian form into polar form"],
    tutorials: ["12:00-13:30 | MST124 Unit 12 Complex Numbers"],
    notes: ""
  },
  {
    date: "2026-04-12",
    day: "Sunday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-04-13",
    day: "Monday",
    module: "MST124",
    topic: "Unit 12: Complex Numbers & Maxima",
    study_hours: 4,
    tasks: ["[2.0 hrs] Sections 5 & 6: de Moivre's formula and Euler's formula", "[2.0 hrs] Unit 12 Maxima Practice: moduli, arguments, roots of polynomials"],
    tutorials: ["18:00-19:00 | Preparing for TMA04"],
    notes: "Finish Unit 12."
  },
  {
    date: "2026-04-14",
    day: "Tuesday",
    module: "MST124",
    topic: "TMA04 - Day 1",
    study_hours: 4,
    tasks: ["[2.0 hrs] Matrix questions (linear equations, networks)", "[2.0 hrs] Sequences questions (recurring decimals)"],
    tutorials: ["18:00-19:00 | Maxima in TMA 04"],
    notes: ""
  },
  {
    date: "2026-04-15",
    day: "Wednesday",
    module: "MST124",
    topic: "TMA04 - Day 2",
    study_hours: 5,
    tasks: ["[2.0 hrs] Complex Numbers questions (Cartesian division, roots)", "[1.5 hrs] Write Maxima code for the arts & crafts simultaneous equations", "[1.5 hrs] Remaining Maxima software questions (polynomial plots)"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-04-16",
    day: "Thursday",
    module: "Both",
    topic: "TMA04 & Topic 9",
    study_hours: 4,
    tasks: ["[1.5 hrs] Write 5-point GMC reflection & Submit TMA04!", "[2.5 hrs] Start Topic 9 Part 1: Expanding Universe (Standard candles)"],
    tutorials: ["18:00-19:00 | MST124 Unit 10 Sequences & Series - Working Behind"],
    notes: "TMA04 submitted well ahead of the April 29th cut-off! (Topic 9 total accommodated time is ~15 hours)"
  },
  {
    date: "2026-04-17",
    day: "Friday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-04-18",
    day: "Saturday",
    module: "SM123",
    topic: "Topic 9: How the Universe works",
    study_hours: 5,
    tasks: ["[2.5 hrs] Finish Topic 9 Part 1: Doppler effect (redshifts) & Hubble relationship", "[2.5 hrs] Topic 9 Part 2: Cooling Universe (CMB radiation)"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-04-19",
    day: "Sunday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-04-20",
    day: "Monday",
    module: "SM123",
    topic: "Topic 9: How the Universe works",
    study_hours: 4,
    tasks: ["[4.0 hrs] Topic 9 Part 3: Evolving Universe (four fundamental interactions)"],
    tutorials: ["18:30-19:30 | SM123 Exploring the Solar System [Overview, Relaxed]"],
    notes: ""
  },
  {
    date: "2026-04-21",
    day: "Tuesday",
    module: "SM123",
    topic: "Topic 9: How the Universe works",
    study_hours: 4,
    tasks: ["[3.5 hrs] Topic 9 Part 4: Future of Universe (Geometry of space, Dark Energy)", "[0.5 hrs] Topic 9 Final Review"],
    tutorials: ["18:00-19:30 | Drop-in - Queries Relating to TMA 04"],
    notes: "Finish Topic 9."
  },
  {
    date: "2026-04-22",
    day: "Wednesday",
    module: "MST124",
    topic: "iCMA44 Prep & Execution",
    study_hours: 4,
    tasks: ["[2.5 hrs] Review notes for Units 8, 9, 10, and 12", "[1.5 hrs] Take the Moodle quiz and Submit iCMA44"],
    tutorials: ["18:30-19:30 | SM123 How the Universe works [Overview]"],
    notes: ""
  },
  {
    date: "2026-04-23",
    day: "Thursday",
    module: "SM123",
    topic: "Python 4: Data analysis",
    study_hours: 4,
    tasks: ["[2.0 hrs] Jupyter Notebooks data analysis introduction", "[2.0 hrs] Write program fitting hydrogen spectrum data"],
    tutorials: ["18:00-19:30 | MST124 Unit 12 Complex Numbers - Working Behind"],
    notes: ""
  },
  {
    date: "2026-04-24",
    day: "Friday",
    module: "SM123",
    topic: "TMA04 - Day 1",
    study_hours: 5,
    tasks: ["[2.5 hrs] Physics questions & Distance to the Moon write-up", "[2.5 hrs] Stardust cratering experiment calculations"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-04-25",
    day: "Saturday",
    module: "SM123",
    topic: "TMA04 - Day 2",
    study_hours: 5,
    tasks: ["[2.0 hrs] Cosmology questions & History of Universe timeline", "[1.5 hrs] Write up nucleosynthesis summaries", "[1.5 hrs] Save Python 4 code/plots, Final radar reflection & Submit TMA04!"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-04-26",
    day: "Sunday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-04-27",
    day: "Monday",
    module: "MST124",
    topic: "General Review 1",
    study_hours: 4,
    tasks: ["[2.5 hrs] Skim Units 1-4 (Algebra, Graphs, Functions, Trig)", "[1.5 hrs] Focus heavily on standard trig identities"],
    tutorials: ["18:30-19:30 | Study skills - Planetary defense"],
    notes: ""
  },
  {
    date: "2026-04-28",
    day: "Tuesday",
    module: "MST124",
    topic: "General Review 2",
    study_hours: 5,
    tasks: ["[2.5 hrs] Skim Units 5-8 (Vectors, Differentiation, Integration)", "[2.5 hrs] Practice tricky integration by parts/substitution problems"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-04-29",
    day: "Wednesday",
    module: "MST124",
    topic: "General Review 3",
    study_hours: 4,
    tasks: ["[2.0 hrs] Skim Units 9, 10, 12 (Matrices, Series, Complex Numbers)", "[2.0 hrs] Matrix inversions and polynomial roots practice"],
    tutorials: [],
    notes: "MST124 TMA04 official cut-off today."
  },
  {
    date: "2026-04-30",
    day: "Thursday",
    module: "SM123",
    topic: "General Review 1",
    study_hours: 4,
    tasks: ["[2.5 hrs] Skim Topics 1-3 (Forces, Energy, Material Worlds)", "[1.5 hrs] Review free-body diagrams, F=ma"],
    tutorials: ["18:30-20:30 | Revision & Exam Techniques - Revising Book A"],
    notes: ""
  },
  {
    date: "2026-05-01",
    day: "Friday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-05-02",
    day: "Saturday",
    module: "SM123",
    topic: "General Review 2",
    study_hours: 5,
    tasks: ["[3.0 hrs] Skim Topics 4-6 (Quantum, Energy in Society, Nuclei/Particles)", "[2.0 hrs] Review alpha/beta decay, half-life equations"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-05-03",
    day: "Sunday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-05-04",
    day: "Monday",
    module: "SM123",
    topic: "General Review 3",
    study_hours: 4,
    tasks: ["[2.5 hrs] Skim Topics 7-9 (Universe, Solar System, Cosmology)", "[1.5 hrs] Review Kepler's third law and Python syntax notes"],
    tutorials: ["18:00-19:30 | Revision & Exam Techniques - Book A"],
    notes: ""
  },
  {
    date: "2026-05-05",
    day: "Tuesday",
    module: "Both",
    topic: "Exam Prep",
    study_hours: 5,
    tasks: ["[3.0 hrs] Attempt an SM123 Moodle-style practice quiz", "[2.0 hrs] Practice substituting values into the SM123 equations sheet"],
    tutorials: ["18:00-19:00 | SM123 TMA04 Planning [Overview]"],
    notes: "MST124 iCMA44 official cut-off today."
  },
  {
    date: "2026-05-06",
    day: "Wednesday",
    module: "SM123",
    topic: "Exam Prep",
    study_hours: 4,
    tasks: ["[2.5 hrs] Review 'How to pass the SM123 exam' notes", "[1.5 hrs] Review TMA feedback for both modules"],
    tutorials: ["18:00-19:00 | SM123 Python 4 [Overview]"],
    notes: ""
  },
  {
    date: "2026-05-07",
    day: "Thursday",
    module: "Both",
    topic: "Exam Prep",
    study_hours: 4,
    tasks: ["[4.0 hrs] Final memorisation of equations and formatting rules"],
    tutorials: ["18:00-19:30 | Revision & Exam Techniques - Book B"],
    notes: ""
  },
  {
    date: "2026-05-08",
    day: "Friday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-05-09",
    day: "Saturday",
    module: "MST124",
    topic: "Mock Exam",
    study_hours: 5,
    tasks: ["[3.0 hrs] Attempt an MST124 Past Paper under timed conditions without notes", "[2.0 hrs] Mark your past paper and review errors"],
    tutorials: [],
    notes: "Early mock exam to identify weak areas for the upcoming live tutorials."
  },
  {
    date: "2026-05-10",
    day: "Sunday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-05-11",
    day: "Monday",
    module: "MST124",
    topic: "Exam Prep",
    study_hours: 5,
    tasks: ["[3.0 hrs] Drill weak areas discovered in mock (e.g., integration by parts, inverses)", "[2.0 hrs] Review definitions and formulas from Book C"],
    tutorials: ["18:00-19:30 | Revision & Exam Techniques (Module-wide) - Book C"],
    notes: ""
  },
  {
    date: "2026-05-12",
    day: "Tuesday",
    module: "SM123",
    topic: "Exam Prep",
    study_hours: 5,
    tasks: ["[3.0 hrs] Review released 'Seen materials' (figures, equations, tables)", "[2.0 hrs] Practice identifying required equations from standard list"],
    tutorials: ["18:00-20:00 | Revision & Exam Techniques - Revising Book C"],
    notes: "Ensure you are familiar with the SM123 Equations, Constants and Conversions PDF."
  },
  {
    date: "2026-05-13",
    day: "Wednesday",
    module: "MST124",
    topic: "Exam Prep",
    study_hours: 5,
    tasks: ["[3.0 hrs] Drill Book D topics (sequence limits, complex number graphing)", "[2.0 hrs] Review definitions and formulas from Book D"],
    tutorials: ["18:00-19:30 | Revision & Exam Techniques (Module-wide) - Book D"],
    notes: ""
  },
  {
    date: "2026-05-14",
    day: "Thursday",
    module: "Both",
    topic: "Exam Prep",
    study_hours: 5,
    tasks: ["[2.5 hrs] Create final summary 'cheat sheet' for MST124 techniques", "[2.5 hrs] Practice 'Essay Style' written answers for SM123, showing full working steps"],
    tutorials: ["10:30-11:30 | How the Universe works (New)", "17:00-18:00 | TMA04 Planning [Interactive]", "18:00-19:30 | Pre-exam briefing with the module team"],
    notes: ""
  },
  {
    date: "2026-05-15",
    day: "Friday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: ["09:00-11:00 | Revision & Exam Techniques - Revising Book D"],
    notes: "Optional morning tutorial available if you want to drop in."
  },
  {
    date: "2026-05-16",
    day: "Saturday",
    module: "SM123",
    topic: "Exam Prep",
    study_hours: 5,
    tasks: ["[2.5 hrs] Practice converting units and magnitudes (e.g. nanometres to metres, eV to J)", "[2.5 hrs] Attempt SM123 Moodle Quiz practice focusing on sensible numeric answers"],
    tutorials: ["09:00-10:30 | Revision & Exam Techniques - Drop-in Session"],
    notes: ""
  },
  {
    date: "2026-05-17",
    day: "Sunday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: ["18:00-19:00 | Study skills - Avoiding plagiarism"],
    notes: ""
  },
  {
    date: "2026-05-18",
    day: "Monday",
    module: "SM123",
    topic: "Exam Prep",
    study_hours: 5,
    tasks: ["[2.5 hrs] Review Topics 1-4 definitions, keeping action words (State, Describe) in mind", "[2.5 hrs] Practice drawing free-body diagrams clearly"],
    tutorials: ["17:30-18:30 | Revision & Exam Techniques (Module-wide)", "18:00-19:00 | Exam Preparation [Overview, Relaxed]"],
    notes: ""
  },
  {
    date: "2026-05-19",
    day: "Tuesday",
    module: "MST124",
    topic: "Exam Prep",
    study_hours: 5,
    tasks: ["[3.0 hrs] Attempt second MST124 Past Paper under timed conditions", "[2.0 hrs] Review marking scheme to understand where partial marks are awarded"],
    tutorials: ["18:00-19:30 | Drop-in - Queries Relating to the Exam", "18:30-19:30 | Exam Preparation [Overview]"],
    notes: ""
  },
  {
    date: "2026-05-20",
    day: "Wednesday",
    module: "SM123",
    topic: "Exam Prep",
    study_hours: 5,
    tasks: ["[2.5 hrs] Review Topics 5-9 equations and units", "[2.5 hrs] Practice typing out 'Essay Style' physics calculations logically for the iCME interface"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-05-21",
    day: "Thursday",
    module: "MST124",
    topic: "Exam Prep",
    study_hours: 5,
    tasks: ["[2.5 hrs] Review Book A & B concepts (Algebra, Functions, Vectors, Differentiation)", "[2.5 hrs] Drill integration methods (by parts, substitution)"],
    tutorials: ["18:30-19:30 | Exam Preparation [Interactive]"],
    notes: ""
  },
  {
    date: "2026-05-22",
    day: "Friday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: ["18:30-20:00 | Study skills - Mission Revision: An Interstellar Escape Room"],
    notes: "SM123 TMA04 official cut-off today!"
  },
  {
    date: "2026-05-23",
    day: "Saturday",
    module: "Both",
    topic: "Final Exam Prep",
    study_hours: 5,
    tasks: ["[3.0 hrs] Light review of the most difficult topics from both modules", "[2.0 hrs] Final check of technical setup for taking the remote iCME and scanning handwritten answers"],
    tutorials: [],
    notes: "Official SM123 Exam Preparation week begins."
  },
  {
    date: "2026-05-24",
    day: "Sunday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-05-25",
    day: "Monday",
    module: "MST124",
    topic: "Exam Prep",
    study_hours: 5,
    tasks: ["[2.5 hrs] Memorize trigonometric identities and derivative/integral tables", "[2.5 hrs] Review previous TMA feedback one last time"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-05-26",
    day: "Tuesday",
    module: "SM123",
    topic: "Exam Prep",
    study_hours: 5,
    tasks: ["[2.5 hrs] Familiarize yourself heavily with the Seen Materials released for the exam", "[2.5 hrs] Review notes on Python programming for Question 10"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-05-27",
    day: "Wednesday",
    module: "Both",
    topic: "Light Review",
    study_hours: 2,
    tasks: ["[1.0 hrs] Rest your mind. Do a quick scan of your own summary notes.", "[1.0 hrs] Prepare desk space, rulers, compass, and calculator for the exam period."],
    tutorials: [],
    notes: "Take it easy today. Get plenty of sleep."
  },
  {
    date: "2026-05-28",
    day: "Thursday",
    module: "MST124",
    topic: "Exam Prep",
    study_hours: 5,
    tasks: ["[3.0 hrs] Complete a final, timed MST124 mock exam paper under exam conditions", "[2.0 hrs] Review your performance against the marking scheme"],
    tutorials: [],
    notes: "Start of the official exam period."
  },
  {
    date: "2026-05-29",
    day: "Friday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: [],
    notes: "Rest your mind to avoid burnout."
  },
  {
    date: "2026-05-30",
    day: "Saturday",
    module: "MST124",
    topic: "Exam Prep",
    study_hours: 4,
    tasks: ["[2.0 hrs] Drill weak areas discovered in the mock exam (e.g., Book C & D topics)", "[2.0 hrs] Practice integration and matrix manipulations"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-05-31",
    day: "Sunday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-06-01",
    day: "Monday",
    module: "MST124",
    topic: "Final Review",
    study_hours: 4,
    tasks: ["[2.0 hrs] Review your cheat sheet and formula summaries", "[2.0 hrs] Ensure familiarity with the required calculus procedures"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-06-02",
    day: "Tuesday",
    module: "MST124",
    topic: "Light Prep",
    study_hours: 2,
    tasks: ["[1.5 hrs] Light review of notes", "[0.5 hrs] Prepare desk, pens, calculator, and any permitted materials"],
    tutorials: [],
    notes: "Rest up for tomorrow's exam."
  },
  {
    date: "2026-06-03",
    day: "Wednesday",
    module: "MST124",
    topic: "EXAM DAY",
    study_hours: 4,
    tasks: ["[3.0 hrs] Sit the MST124 Exam", "[1.0 hrs] Scan and upload your written answers"],
    tutorials: [],
    notes: "Good luck! One down, one to go.",
    isExam: true
  },
  {
    date: "2026-06-04",
    day: "Thursday",
    module: "SM123",
    topic: "Travel to London & Exam Prep",
    study_hours: 4,
    tasks: ["[2.0 hrs] Travel from Guernsey to London via ferry. Shift focus fully to SM123", "[2.0 hrs] Review Topics 1-5 notes and definitions while travelling"],
    tutorials: [],
    notes: "Travel day! Utilise the 4 hours on the ferry and train for study.",
    isTravel: true
  },
  {
    date: "2026-06-05",
    day: "Friday",
    module: "Rest",
    topic: "Wedding Day - Saj and Ailsa",
    study_hours: 0,
    tasks: ["[0.0 hrs] Attend Saj and Ailsa's wedding (12:00 - 20:00)"],
    tutorials: [],
    notes: "No study scheduled today. Enjoy the wedding!",
    isWedding: true
  },
  {
    date: "2026-06-06",
    day: "Saturday",
    module: "SM123",
    topic: "Travel to Guernsey & Exam Prep",
    study_hours: 4,
    tasks: ["[2.0 hrs] Travel from London to Guernsey. Review Topics 6-9 notes and definitions", "[2.0 hrs] Review Python programming syntax and your previous scripts"],
    tutorials: [],
    notes: "Travel day back home! Fit in your 4 hours of study on the journey.",
    isTravel: true
  },
  {
    date: "2026-06-07",
    day: "Sunday",
    module: "Rest",
    topic: "Rest Day",
    study_hours: 0,
    tasks: [],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-06-08",
    day: "Monday",
    module: "SM123",
    topic: "Exam Prep",
    study_hours: 4,
    tasks: ["[2.5 hrs] Complete a full Moodle Quiz practice paper", "[1.5 hrs] Practice checking units and testing for sensible numerical answers"],
    tutorials: [],
    notes: ""
  },
  {
    date: "2026-06-09",
    day: "Tuesday",
    module: "SM123",
    topic: "Light Prep",
    study_hours: 2,
    tasks: ["[1.0 hrs] Final read-through of 'Seen materials' and the Equations sheet", "[1.0 hrs] Review 'How to pass the SM123 exam' tips"],
    tutorials: [],
    notes: "Rest up for tomorrow's exam."
  },
  {
    date: "2026-06-10",
    day: "Wednesday",
    module: "SM123",
    topic: "EXAM DAY",
    study_hours: 4,
    tasks: ["[3.0 hrs] Sit the 3-hour SM123 iCME Moodle Quiz Exam", "[1.0 hrs] Scan and upload any required hand-written 'Essay Style' answers"],
    tutorials: [],
    notes: "Congratulations, you have finished both modules!",
    isExam: true
  }
];

export const moduleColors = {
  MST124: {
    name: "Mathematics",
    bg: "bg-sky-100 dark:bg-sky-900/30",
    text: "text-sky-900 dark:text-sky-100",
    border: "border-sky-300 dark:border-sky-700",
    indicator: "bg-sky-600",
    badgeBg: "bg-sky-600",
    badgeText: "text-white"
  },
  SM123: {
    name: "Science",
    bg: "bg-emerald-100 dark:bg-emerald-900/30",
    text: "text-emerald-900 dark:text-emerald-100",
    border: "border-emerald-300 dark:border-emerald-700",
    indicator: "bg-emerald-600",
    badgeBg: "bg-emerald-600",
    badgeText: "text-white"
  },
  Both: {
    name: "Both Modules",
    bg: "bg-violet-100 dark:bg-violet-900/30",
    text: "text-violet-900 dark:text-violet-100",
    border: "border-violet-300 dark:border-violet-700",
    indicator: "bg-violet-600",
    badgeBg: "bg-violet-600",
    badgeText: "text-white"
  },
  Rest: {
    name: "Rest Day",
    bg: "bg-slate-100 dark:bg-slate-700/50",
    text: "text-slate-600 dark:text-slate-300",
    border: "border-slate-300 dark:border-slate-600",
    indicator: "bg-slate-400",
    badgeBg: "bg-slate-500",
    badgeText: "text-white"
  }
};
